window.chartPlanungsindexpie = {
	init: function (data, targetDiv) {
		this.chart = new Highcharts.Chart(targetDiv, {
			colors: [
				getGradientColor(farbeEinnahmen),
				getGradientColor(kapitalanlagen),
				getGradientColor(farbeSonstigeVermoegenswerte),
				getGradientColor(farbeImmobilien),
				getGradientColor(farbeUnternehmen),
			],
			chart: {
				type: "pie",
				spacingTop: 0,
				spacingBottom: 0,
				spacingLeft: 0,
				spacingRight: 0,
				events: {
					render: function () {
						var chart = this,
							series = chart.series,
							allZeros = true
						for (var i = 0; i < series[0].data.length; i++) {
							if (series[0].data[i].y !== 0) {
								allZeros = false
							}
						}
						if (allZeros) {
							//chart.showLoading("Keine Daten vorhanden")
						} else {
							chart.hideLoading()
						}
					},
				},
			},

			tooltip: {
				enabled: false,
			},

			plotOptions: {
				series: {
					enableMouseTracking: false,
					animation: {
						duration: 0,
					},
				},
			},

			series: [
				{
					type: "pie",
					edgeWidth: 0,
					//edgeColor: 'green',
					data: data,
				},
			],
		})
	},

	update: function () {
		if (typeof this.chart !== "undefined") {
			this.chartdata().forEach(
				function (serie) {
					this.chart.get(serie.id).setData(serie.data, false)
				}.bind(this),
			)

			this.chart.redraw({ duration: chartAnimationDuration })
		}
	},
}
